import { Component, OnDestroy, OnInit } from '@angular/core';
import { iBannerNotification, NotificationService, NotificationType } from '@services/notifications.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-notification-banner',
  templateUrl: './notification-banner.component.html',
  styleUrl: './notification-banner.component.scss'
})
export class NotificationBannerComponent implements OnInit, OnDestroy {

  public showInfo: boolean = true;
  public showWarning: boolean = true;
  public showError: boolean = true;
  public showSystem: boolean = true;
  public showSuccess: boolean = true;

  toggleView(type: string) {
    switch (type) {
      case NotificationType.Info: this.showInfo = !this.showInfo; break;
      case NotificationType.Warning: this.showWarning = !this.showWarning; break;
      case NotificationType.Error: this.showError = !this.showError; break;
      case NotificationType.System: this.showSystem = !this.showSystem; break;
      case NotificationType.Success: this.showSuccess = !this.showSuccess; break;
    }
  }

  public notifications: iBannerNotification[] = [];
  private sub!: Subscription;

  constructor(private notificationService: NotificationService) { }

  ngOnInit() {
    this.sub = this.notificationService.notifications$.subscribe(stack => {
      /** Only display none snoozed Notifications */
      this.notifications = stack.filter(n => n.snoozed == false);
    });
  }

  get info() {
    return this.notifications.filter(n => n.type == NotificationType.Info)
  }

  get warnings() {
    return this.notifications.filter(n => n.type == NotificationType.Warning)
  }

  get errors() {
    return this.notifications.filter(n => n.type == NotificationType.Error)
  }

  get system() {
    return this.notifications.filter(n => n.type == NotificationType.System)
  }

  get success() {
    return this.notifications.filter(n => n.type == NotificationType.Success)
  }

  dismiss(notificationUID:string) {
    this.notificationService.remove(notificationUID);
  }

  snooze(notificationUID: string) {
    this.notificationService.snooze(notificationUID);
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}